import { TenantTemplateRouterCore } from "@components/tenant/TenantTemplateRouter";
import DefaultInvoicePrint from "./default";

const templates = import.meta.glob<{ default: React.ComponentType<any> }>(
  "/src/pages/user/Quotes/Print/templates/*/index.tsx"
);

type QuotePrintProps = {
};

export default function QuotePrint(props: QuotePrintProps) {
  return (
    <TenantTemplateRouterCore<QuotePrintProps>
      templates={templates}
      DefaultComponent={DefaultInvoicePrint}
      passProps={props}
    />
  );
}